import request from '@/utils/request'

export function getBackgroundTemplateList() {
  return request.get('/asset/template/list')
}

export function saveBackgroundTemplate(imageUrl) {
  return request.post('/asset/template/save', { image_url: imageUrl })
}

export function deleteBackgroundTemplate(templateId) {
  return request.post('/asset/template/delete', { template_id: templateId })
}

/** POST /asset/template/sort — 更新展示顺序（sort / sort_order 等价） */
export function sortBackgroundTemplate(templateId, sort) {
  const n = Number(sort)
  return request.post('/asset/template/sort', {
    template_id: templateId,
    sort: n,
    sort_order: n
  })
}

export function getUploadTempSignature(filename) {
  return request.post('/uploads/uploads/get_temp_signature', { filename })
}
